






import Vue, { PropType } from 'vue';

export default Vue.extend({
  name: 'GChatMessageBlock',
  props: {
    text: {
      type: String as PropType<string>,
      default: '',
    },
  },
});
